import { Table } from "../../../components/table.component";
import VuiTypography from "../../../../../components/VuiTypography";
import { AppCodeState } from "./codes-state.component";
import VuiBox from "components/VuiBox";
import { useState } from "react";
import { AppCodesJustificationInput } from "./codes-justification-input.component";
import { AppCodesDeliveredAtDateInput } from "./codes-delivered-at-component";

export function AppCodesTable({
  codesTableRows,
  codesTableColumns,
  codesButtonStates,
  fetchPromoCodes,
  updatePromeCode,
}) {
  const [oderByKey, setOrderByKey] = useState("");
  const [oderByType, setOrderByType] = useState("");
  const handleChangeSort = (newOrderByKey, newOrderByType) => {
    if (newOrderByKey === oderByKey && newOrderByType === oderByType) {
      setOrderByKey("");
      setOrderByType("");
    } else {
      setOrderByKey(newOrderByKey);
      setOrderByType(newOrderByType);
    }
    fetchPromoCodes({
      key: "order",
      value: newOrderByKey + "-" + newOrderByType,
      clear: newOrderByKey === oderByKey && newOrderByType === oderByType,
    });
  };
  return (
    <Table
      columns={codesTableColumns.map((item) => ({
        ...item,
        property: item.property,
        label: (
          <VuiTypography
            color="white"
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: "400",
              minWidth: "fit-content",
            }}
          >
            {item.label}
          </VuiTypography>
        ),
        responsive: item.responsive,
        align: "left",
        styles: item.styles,
        dropDownName: item.label,
      }))}
      rows={codesTableRows.map((item) => ({
        ...item,
        id: item.challengeAffiliateCodeId,
        code: {
          value: item.code,
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                letterSpacing: "0.5px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.code ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        label: {
          value: item.label,
          default: (
            <VuiBox sx={{ display: "flex", gap: "0.3rem" }}>
              <VuiTypography
                color="white"
                sx={({ breakpoints }) => ({
                  fontSize: "12px",
                  letterSpacing: "0.5px",
                  lineHeight: "15.6px",
                  fontWeight: "500",
                  [breakpoints.up("md")]: {
                    display: "none",
                  },
                })}
              >
                challenge {item.label}
              </VuiTypography>
              <VuiTypography
                color="white"
                sx={({ breakpoints }) => ({
                  fontSize: "12px",
                  letterSpacing: "0.5px",
                  lineHeight: "15.6px",
                  fontWeight: "500",
                  [breakpoints.down("md")]: {
                    display: "none",
                  },
                })}
              >
                {item.label ?? item.defaultValue}
              </VuiTypography>
            </VuiBox>
          ),
        },
        lastName: {
          value: item.lastName,
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                letterSpacing: "0.5px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.lastName && item.firstName
                ? `${item.lastName} ${item.firstName}`
                : item.defaultValue}
            </VuiTypography>
          ),
        },
        justification: {
          value: item.justification,
          default: (
            <AppCodesJustificationInput
              value={item.justification}
              defaultValue={item.defaultValue}
              updateInfoPromeCode={(justificacion) =>
                updatePromeCode({
                  newInfoPromeCode: {
                    affiliateCodeId: item.challengeAffiliateCodeId,
                    justificacion,
                  },
                })
              }
            />
          ),
        },
        deliveredAt: {
          value: item.deliveredAt,
          default: (
            <AppCodesDeliveredAtDateInput
              value={item.deliveredAt}
              defaultValue={item.defaultValue}
              updateInfoPromeCode={(deliveredAt) =>
                updatePromeCode({
                  newInfoPromeCode: {
                    affiliateCodeId: item.challengeAffiliateCodeId,
                    deliveredAt,
                  },
                })
              }
            />
          ),
        },
        updatedAt: {
          value: item.updatedAt,
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                letterSpacing: "0.5px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.updatedAt ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        email: {
          value: item.email,
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                letterSpacing: "0.5px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.email ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        used: {
          value: item.used,
          default: <AppCodeState state={item.used} codesButtonStates={codesButtonStates} />,
          special: (
            <AppCodeState
              state={item.used}
              codesButtonStates={codesButtonStates}
              responsive={false}
            />
          ),
        },
      }))}
      handleChangeSort={handleChangeSort}
      oderByKey={oderByKey}
      oderByType={oderByType}
    />
  );
}
